export default {
  en: {
    translation: {
      instagram: {
        no_auth_title: 'Upload photos from your Instagram account.',
        no_auth_action: 'Connect to Instagram',

        header_title: 'Your Recent Instagram Photos',

        authenticating: 'Authenticating...',
      },
    },
  },
};
